<template>
    <component :is="type" class="text" :class="[type, $mq]">
        <slot />
    </component>
</template>

<script>
    export default {
        name: 'base-text',

        props: {
            type: {
                type: String,
                required: false,
                default() {
                    return 'h2';
                },
            },
        },
    };
</script>

<style lang="scss" scoped>
    .text {
        color: #fff;
        margin: 0;
        text-shadow: 0px 3px 6px rgba(#000, 0.2);
    }

    .h1,
    .h2,
    .h3,
    .h4,
    .h5,
    .h6 {
        font-family: $heading-font;
    }

    .h1 {
        font-size: 60px;
        font-weight: bold;

        &.tablet {
            font-size: 45px;
        }

        &.mobile {
            font-size: 35px;
        }
    }

    .h2 {
        font-size: 25px;
        opacity: 0.7;

        &.tablet {
            font-size: 20px;
        }

        &.mobile {
            font-size: 15px;
        }
    }

    .h3 {
        font-size: 35px;

        &.tablet {
            font-size: 30px;
        }

        &.mobile {
            font-size: 25px;
        }
    }

    .h4 {
        font-size: 25px;

        &.mobile {
            font-size: 20px;
        }
    }

    .p {
        line-height: 1.5;

        &.tablet {
            font-size: 20px;
        }

        &.mobile {
            font-size: 14px;
        }
    }
</style>
